function greater(a, b) {
  return a > b;
}

greater.op = '>';

export default greater;
